import React, { useState } from 'react';
import axios from 'axios';

const ClientLogin = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await axios.post('https://app.hayahost.net/api/client/login', form);
      localStorage.setItem('client_token', response.data.token);
      localStorage.setItem('client_info', JSON.stringify(response.data.client));
      window.location.href = '/client/dashboard';
    } catch (err) {
      setError(err.response?.data?.message || 'خطأ في تسجيل الدخول');
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>🏦</div>
        <h1 style={styles.title}>نظام الحوالات والصيرفة</h1>
        <p style={styles.subtitle}>بوابة العملاء والشركات</p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>اسم المستخدم</label>
            <input style={styles.input} value={form.username}
              onChange={e => setForm({...form, username: e.target.value})}
              placeholder="أدخل اسم المستخدم" required />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>كلمة السر</label>
            <input style={styles.input} type="password" value={form.password}
              onChange={e => setForm({...form, password: e.target.value})}
              placeholder="أدخل كلمة السر" required />
          </div>
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? '⏳ جاري الدخول...' : '🔐 تسجيل الدخول'}
          </button>
        </form>

        <div style={styles.footer}>
          <a href="/login" style={styles.link}>دخول الرئيسي</a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: 'linear-gradient(135deg, #1a237e, #0d47a1)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  card: { background: 'white', borderRadius: '20px', padding: '40px', width: '100%', maxWidth: '400px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', textAlign: 'center' },
  logo: { fontSize: '50px', marginBottom: '15px' },
  title: { color: '#1a237e', fontSize: '22px', marginBottom: '5px' },
  subtitle: { color: '#666', fontSize: '14px', marginBottom: '30px' },
  error: { background: '#ffebee', color: '#c62828', padding: '10px', borderRadius: '8px', marginBottom: '15px', fontSize: '13px' },
  inputGroup: { marginBottom: '15px', textAlign: 'right' },
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: '10px', fontSize: '14px', direction: 'rtl', boxSizing: 'border-box' },
  btn: { width: '100%', background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '14px', borderRadius: '10px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold', marginTop: '10px' },
  footer: { marginTop: '20px' },
  link: { color: '#1a237e', fontSize: '13px', textDecoration: 'none' },
};

export default ClientLogin;